module.exports = __webpack_public_path__ + "img/mentor1.aa47461.jpg";